<template>
    <div>
        <div class="brach-nav-box">
            <branch-search :searchValue="searchValue"></branch-search>
            <header-child></header-child>
        </div>
        <div class="header-empty"></div>
    </div>
</template>

<script>
import BranchSearch from '@/components/BranchSearch'
import HeaderChild from '@/components/HeaderChild'
export default {
    props: {
       
    },
    components: {
        BranchSearch,
        HeaderChild
    },
    data() {
        return {
            menusList:[],
            flag:false,
            searchValue:''
        };
    },
    computed:{
        
    },
    created(){
       
    },
    methods:{
       
    }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BranchHeader.vue